var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
var KtsReceptionContentComponent = /** @class */ (function (_super) {
    __extends(KtsReceptionContentComponent, _super);
    function KtsReceptionContentComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.items = [];
        _this.toggles = [];
        _this.users = [];
        return _this;
    }
    KtsReceptionContentComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.getType();
    };
    KtsReceptionContentComponent.prototype.getType = function () {
        var _this = this;
        this.service.getType('AU_NAME').subscribe(function (rec) { return _this.users = rec; });
    };
    KtsReceptionContentComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    KtsReceptionContentComponent.prototype.onSubscribe = function (data) {
        this.items = [];
        if (typeof data.items !== 'undefined' && data.items instanceof Array) {
            this.items = data.items;
        }
        for (var i = 0; i < this.items.length; i++) {
            if (typeof this.toggles[i] === 'undefined') {
                this.toggles[i] = true;
            }
        }
    };
    KtsReceptionContentComponent.prototype.onEvent = function (e1, e2, rec) {
        if (e2 === 'open') {
            this.setToggle(true);
        }
        else if (e2 === 'close') {
            this.setToggle(false);
        }
        else if (e2 === 'toggle') {
            this.toggles[rec] = !this.toggles[rec];
        }
    };
    KtsReceptionContentComponent.prototype.setToggle = function (flg) {
        for (var i = 0; i < this.items.length; i++) {
            this.toggles[i] = flg;
        }
    };
    KtsReceptionContentComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-reception-content',
                    template: "<div id=\"{{ componentName }}\">\n  <p *ngIf=\"items.length === 0\">{{ (msg | async)['au.COMPONENT.KtsReceptionContentComponent.label.noContent'] }}</p>\n  <div *ngIf=\"items.length > 0\" class=\"-txtalnright -mb-1\">\n    <a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'open', '')\">{{ (msg | async)['au.COMPONENT.KtsReceptionContentComponent.label.openAll'] }}</a>\n    <a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'close', '')\">{{ (msg | async)['au.COMPONENT.KtsReceptionContentComponent.label.closeAll'] }}</a>\n  </div>\n  <div>\n    <div *ngFor=\"let item of items; let index = index;\" class=\"accordion\">\n      <div class=\"accordion_header\" (click)=\"onEvent($event, 'toggle', index)\">\n        <div class=\"row\">\n          <div class=\"col-sm-6\">\n            <column-formlabel [col]=\"{controlType: 'select', params: {options: users}}\" [val]=\"item.cby\"></column-formlabel>\n          </div>\n          <div class=\"col-sm-6 -txtalnright\">\n            <column-formlabel [col]=\"{controlType: 'datetime'}\" [val]=\"item.cdate\"></column-formlabel>\n          </div>\n        </div>\n      </div>\n      <div class=\"accordion_content\" [hidden]=\"!toggles[index]\">\n        <div class=\"row\">\n          <div class=\"col-sm-12\">\n            <dl class=\"form\">\n              <dt></dt>\n              <dd class=\"form_dd\">\n                <ul>\n                  <li class=\"form_li form_li-w100per\">\n                    <column-formreadonly [col]=\"{controlType: 'textarea'}\" [val]=\"item.content\" [msg]=\"(msg | async)\"></column-formreadonly>\n                  </li>\n                </ul>\n              </dd>\n            </dl>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    KtsReceptionContentComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService }
    ]; };
    return KtsReceptionContentComponent;
}(ContentBaseComponent));
export { KtsReceptionContentComponent };
//# sourceMappingURL=reception-content.component.js.map